import { gql } from "@apollo/client";

export const UPDATE_CASE_SCHEDULE = gql`
  mutation UpdateCaseSchedule($data: UpdateCaseScheduleInputData!) {
    updateCaseSchedule(data: $data) {
      id
      title
      createdAt
      date
      time
      duration
      status
      location
      locationDetails
      orgId
      caseId
    }
  }
`;
